module.exports = __webpack_public_path__ + "img/bind-success-copy.67c7d78a.png";